<template>
  <div>
    <b-list-group>
      <b-list-group-item v-for="item in navlist" :key="item.index">
        <b-link :to="item.link">{{item.title}}</b-link>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  data () {
    return {
      navlist: [
        {
          title: "News",
          link: "/news"
        },
        {
          title: "Promos",
          link: "/promos"
        },
        {
          title: "Articles",
          link: "/articles"
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.list-group {
      margin-bottom: 40px;
      .list-group-item {
          padding: 0;
        a {
          color: #434343;
          text-decoration: none;
          display: block;
          padding: 12px 20px;
        }
        .router-link-exact-active {
          background: $base-blue-nav;
          color: #fff;
        }
      }
      .list-group-item.active {
        a {
          color: #fff;
        }
      }
    }
</style>